import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../auth/Session";
import { ErreurApi } from "../api/client";

/**
 * Connexion de l'EQUIPE MDC.
 *
 * Le portail client a desormais son propre ecran — voir
 * `portail/ConnexionClient` — parce que le lien d'invitation n'ouvre plus de
 * session : il ne sert qu'une fois, a etablir des identifiants.
 */
export function Connexion() {
  const { connecterStaff } = useSession();
  const naviguer = useNavigate();

  const [nom, setNom] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: React.FormEvent) {
    e.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      await connecterStaff(nom, motDePasse);
      naviguer("/dossiers", { replace: true });
    } catch (e) {
      // Le message vient du serveur et ne dit JAMAIS si c'est l'identifiant ou
      // le mot de passe qui est faux. On ne l'enrichit pas ici.
      setErreur(e instanceof ErreurApi ? e.message : "Connexion impossible.");
    } finally {
      setEnCours(false);
    }
  }

  return (
    <main className="connexion">
      <header className="marque">
        <div className="marque__monogramme">MDC</div>
        <div className="marque__nom">La Maison de la Conformité</div>
        <p className="marque__sous-titre">SARL · Espace collaborateurs</p>
      </header>

      <p className="resume" style={{ textAlign: "center", marginBottom: "1.2rem" }}>
        Connectez-vous avec votre <strong>NOM</strong> et le mot de passe fourni
        par le gérant.
      </p>

      <form onSubmit={soumettre}>
        <label>
          Nom
          {/* L'identifiant est le NOM, pas l'email : les départements MDC
              partagent une adresse mail. */}
          <input
            value={nom}
            onChange={(e) => setNom(e.target.value)}
            autoComplete="username"
            placeholder="Ex. BILE SÉVERIN"
            required
          />
        </label>
        <label>
          Mot de passe
          <input
            type="password"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            autoComplete="current-password"
            placeholder="Votre mot de passe"
            required
          />
        </label>

        {erreur && (
          <p className="alerte" role="alert">
            {erreur}
          </p>
        )}

        <button type="submit" disabled={enCours}>
          {enCours ? "Vérification…" : "Se connecter"}
        </button>
      </form>
    </main>
  );
}
